module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('titles.companySetup')
    }
  }, [_c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "only-hide": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-alert', {
    staticClass: "mb-3",
    attrs: {
      "info": "",
      "value": true
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('companySetup.description')) + "\n      ")]), _vm._v(" "), _c('public-key-input', {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.$t('companySetup.publicKey'),
      "required": ""
    },
    model: {
      value: (_vm.publicKey),
      callback: function($$v) {
        _vm.publicKey = $$v
      },
      expression: "publicKey"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c53131","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CompanySetup.vue
// module id = 1059
// module chunks = 1